export enum OfferNetworkProvider {
  Disco = "disco",
  Falcon = "falcon",
  Rokt = "rokt",
  Uptick = "uptick",
}
